import React, { useState } from 'react';
import '../App.css'; // Ensure the path is correct

const StudentForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        education: '',
        state: '',
        city: '',
    });
    const [responseMessage, setResponseMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = ({ target: { name, value } }) => {
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation for all fields
        if (
            !formData.name ||
            !formData.email ||
            !formData.contact ||
            !formData.education ||
            !formData.state ||
            !formData.city
        ) {
            setResponseMessage('All fields are required.');
            setIsSuccess(false);
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/submit-student-form`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setResponseMessage(data.message || 'Form submitted successfully! We will contact you soon.');
                setIsSuccess(true);
                setFormData({
                    name: '',
                    email: '',
                    contact: '',
                    education: '',
                    state: '',
                    city: '',
                });
            } else {
                throw new Error(data.message || 'Unexpected error occurred.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setResponseMessage(`Error submitting form: ${error.message}`);
            setIsSuccess(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg max-w-lg mx-auto">
            <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-6 text-center">🎓 Join the Full Stack Development Course</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                    type="text"
                    name="contact"
                    placeholder="Enter your contact number"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                    type="text"
                    name="education"
                    placeholder="Enter your education qualification"
                    value={formData.education}
                    onChange={handleChange}
                    required
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                    type="text"
                    name="state"
                    placeholder="Enter your state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                    type="text"
                    name="city"
                    placeholder="Enter your city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full p-3 rounded-lg text-white font-bold ${
                        isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>
            {responseMessage && (
                <p className={`mt-4 text-center font-bold ${isSuccess ? 'text-green-600' : 'text-red-600'}`}>
                    {responseMessage}
                </p>
            )}
        </div>
    );
};

export default StudentForm;
